import React from "react";
import "./Home.css";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import ProjectCard, { ReverseProjectCard } from "../Components/ProjectCard";
import { FaArrowRightLong } from "react-icons/fa6";
import Footer from "../Components/Footer";
import Contact from "../Components/Contact";
import { Link } from "react-router-dom";

const Home = () => {
  document.title = "Rizatzmi";

  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <section className="Home-Section">
        <Hero />
      </section>
      <section className="Project-Section">
        <h1 className="Portfolio-Title">PORTFOLIO</h1>
        <p className="Portfolio-Subtitle">Some works i have been made</p>
        <ProjectCard
          title="Expinc"
          description="Expinc is the website of a company engaged in technology, especially in the field of Virtual Reality and Augmented Reality. I had the opportunity to be entrusted with redesigning their website."
          image="/Assets/Expinc.jpeg"
          link="https://expinc.io/"
        />
        <ReverseProjectCard
          title="Studio-eXp"
          description="studio-eXp is a game development service website that focuses on making games aimed at children as educational materials, as well as being fun to play."
          image="/Assets/Studio-eXp.jpeg"
          link="https://studio-exp.io/"
        />
        <ProjectCard
          title="Helden-Inc"
          description="Helden-Inc is an innovative company that offers services for conceptualizing a game that is perfect for fun, challenge and story. They conceptualize innovative games for businesses and the public sector."
          image="/Assets/Helden-Inc.jpeg"
          link="https://helden-inc.com/"
        />
        <Link className="Link-More" to={"/portfolio"}>
          <div className="Row-Project">
            <h1 className="More-Portfolio">Some more awesome Projects!</h1>
            <div className="Button-More">
              <FaArrowRightLong className="Arrow" />
            </div>
          </div>
        </Link>
      </section>
      <section className="Contact-Section">
        <Contact />
      </section>
      <section className="Footer-Section">
        <Footer />
      </section>
    </>
  );
};

export default Home;
